import type { ReactNode} from 'react';
import { useState } from 'react';

import classNames from 'classnames';

import type { RewardPool, RewardPoolTicketCurrency } from '@shared/api/types/rewardPools';

import { ListItemButton } from '../../List/ListItemButton';
import { ViewTicketsModal } from './ViewTicketsModal';

type Props = {
  rewardPool: RewardPool;
  dataQaAttribute: string;
  className?: string;
  children: ReactNode;
  invisible?: boolean;
  currency?: RewardPoolTicketCurrency;
};

export const ViewTicketsButton = ({
  rewardPool,
  dataQaAttribute,
  currency,
  invisible = false,
  ...props
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModalHandler = () => {
    setIsModalOpen(false);
  };

  const openModalHandler = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      {isModalOpen && (
        <ViewTicketsModal
          open={isModalOpen}
          onOpenChange={setIsModalOpen}
          rewardPool={rewardPool}
          closeModal={closeModalHandler}
          currency={currency}
        />
      )}
      <ListItemButton
        {...props}
        className={classNames({ invisible: invisible })}
        variant="secondary"
        data-qa={dataQaAttribute}
        onClick={openModalHandler}
      />
    </>
  );
};
